module.exports = __webpack_public_path__ + "912bd0fda664613609bead385f96fc11.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/promo-and-button-modal-window/icon-open-white.png
// module id = 806
// module chunks = 0 1